export const translationKeys = {
  NAMESPACE: 'Checkbox_Group',
  INLINE_ERROR_MESSAGE_DEFAULT_ERROR_MESSAGE:
    'Checkbox_Group_On_Stage_Error_Text_Label',
  INLINE_ERROR_MESSAGE_DEFAULT_VALIDATION_MESSAGE:
    'Checkbox_Group_No_Selection_Validation_Message',
  CHECKBOX_GROUP_REQUIRED_ARIA_LABEL: 'Checkbox_Group_Required_Aria_Label',
} as const;

export const TestIds = {
  label: 'label',
  labelLegend: 'label-legend',
  labelRequiredIndicator: 'label-required-indication',
  items: 'items',
};
